module.exports = __webpack_public_path__ + "img/symbol_1.8ea65331.png";